import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ListingImage } from '../../../elements-image/listing-image';
import { BookingSummaryItem } from '../../common/items/BookingSummaryItem';

const useTypes = defineMessages({
  'Off-Site': {
    id: 'inbox.summary_props.use_type.meeting',
    defaultMessage: '(Meeting)'
  },
  Event: {
    id: 'inbox.summary_props.use_type.event',
    defaultMessage: '(Event)'
  },
  Production: {
    id: 'inbox.summary_props.use_type.production',
    defaultMessage: '(Production)'
  }
});

export const BookingSummarySpace = ({
  booking,
  iosWebViewConfig,
  isGuestView
}) => {
  const listing = booking?.listing;
  const localizedUseType = useTypes[listing?.use_type];

  const imgId =
    listing?.cover_img_id || (listing?.images || [])[0]?.external_id;

  return (
    !isEmpty(listing) && (
      <div>
        <BookingSummaryItem
          testingId='booking-summary-space'
          label={
            <FormattedMessage
              id='inbox.summary_props.listing_image_view'
              defaultMessage='Space'
            />
          }
        >
          {iosWebViewConfig?.isWebView ? (
            <span>{listing.title}</span>
          ) : (
            <a
              target='_blank'
              href={`/pages/listings/${listing.listing_id || listing._id}`}
            >
              {listing.title}{' '}
              {!isGuestView && !!localizedUseType && (
                <FormattedMessage {...localizedUseType} />
              )}
            </a>
          )}
        </BookingSummaryItem>
        <div
          className='margin-md-top margin-xl-bottom overflow-hidden'
          style={{ borderRadius: '8px' }}
        >
          <ListingImage
            ratio={1.689}
            widths={[256, 512, 768]}
            defaultWidth={512}
            defaultHeight={305}
            alt='Peerspace'
            imgId={imgId}
            style='img-responsive listing-image'
          />
        </div>
      </div>
    )
  );
};

BookingSummarySpace.propTypes = {
  booking: PropTypes.object.isRequired,
  imgMargins: PropTypes.number,
  iosWebViewConfig: PropTypes.shape({
    isWebView: PropTypes.bool
  })
};
